import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { PopoverDirective } from '@app/core/components/popover/popover.directive';
import { ModalService } from '@app/core/services/modal.service';
import { PopupService } from '@app/core/services/popup.service';
import { StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';
import { Subscription } from 'rxjs';
import { GridOptions } from '../../grid.types';
import { GridService } from '../../grid.service';
import { GridComponent } from '../../grid.component';

@Component({
    selector: 'tt-chip-cell-renderer',
    templateUrl: './chip-cell-renderer.component.html',
    styleUrls: ['./chip-cell-renderer.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ChipCellRendererComponent implements ICellRendererAngularComp, OnDestroy {
    public idList: string[] = [];

    public chipsList: { [key: string]: any }[] = [];

    public dataName = 'item_name';

    public dataState = 'item_state';

    public dataParms = 'item_parms';

    public dataColor = 'item_color';

    public dataTextColor = 'item_text_color';

    private popupClosed$?: Subscription;

    private params?: ICellRendererParams<any, any, any> & { grid: GridComponent };

    @ViewChild(PopoverDirective)
    public popover?: PopoverDirective;

    constructor(
        private utility: UtilityService,
        private state: StateService,
        private popup: PopupService,
        private modal: ModalService,
        private gridService: GridService,
    ) {}

    public async onClick(event: MouseEvent, chip: any) {
        if (!this.params) return;

        const state = chip[this.dataState];
        const params = chip[this.dataParms];

        if (chip[this.dataState]) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();

            if (chip.type === 'popup') {
                const popup = await this.popup.openPopup(state + (!!params ? '/' + params : ''));

                this.popupClosed$ = popup?.closed.subscribe({
                    next: (closed) => {
                        if (closed) {
                            if (!this.params) return;
                            this.gridService.onStateClosed({ grid: this.params.grid, colDef: this.params.colDef, node: this.params.node, ...chip });
                        }
                    },
                });
            } else if (chip.type === 'modal') {
                const result = await this.modal.openStateDialog({ state: chip[this.dataState], params: chip[this.dataParms] });

                this.gridService.onStateClosed({ grid: this.params.grid, colDef: this.params.colDef, node: this.params.node, ...chip });
            } else {
                if (this.utility.isModifierKeyPressed(event)) {
                    this.state.newTab(chip[this.dataState], chip[this.dataParms]);
                } else {
                    this.state.go(chip[this.dataState], chip[this.dataParms]);
                }
            }
        }
    }

    agInit(params: ICellRendererParams<any, any, any> & { grid: GridComponent }): void {
        this.params = params;
        if (typeof params.value === 'string' && params.value.startsWith('[') && params.value.endsWith(']')) {
            try {
                const list = JSON.parse(params.value);

                if (Array.isArray(list)) {
                    this.chipsList = list.map((item: any) => ({ ...item, [this.dataTextColor]: this.getTextColor(item) })) ?? [];
                }
            } catch (error) {
                console.error(error);
            }
        } else if (typeof params.value === 'string') {
            this.idList = params.value?.split(',').filter((item: any) => !!item);
        } else if (Array.isArray(params.value)) {
            this.chipsList = params.value?.map((item: any) => ({ ...item, [this.dataTextColor]: this.getTextColor(item) })) ?? [];
        }
    }

    refresh(params: ICellRendererParams<any, any, any>): boolean {
        return false;
    }

    ngOnDestroy(): void {
        this.popupClosed$?.unsubscribe();
    }

    private getTextColor(chip: any) {
        if (this.dataColor in chip && !!chip[this.dataColor] && typeof chip[this.dataColor] === 'string') {
            const red = parseInt(chip[this.dataColor].substring(1, 3), 16);
            const green = parseInt(chip[this.dataColor].substring(3, 5), 16);
            const blue = parseInt(chip[this.dataColor].substring(5, 7), 16);

            let brightness;

            brightness = red * 299 + green * 587 + blue * 114;
            brightness = brightness / 255000;

            // values range from 0 to 1
            // anything greater than 0.5 should be bright enough for dark text
            if (brightness < 0.51) {
                // return 'white';
                return 'white';
            } else {
                // return 'black';
                return 'black';
            }
        } else {
            return 'var(--mdc-chip-label-text-color, currentColor)';
        }
    }
}
